export default [
  {
    name: 'rooms',
    path: '/rooms',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Salas',
      icon: 'dvr',
      label: 'Salas',
      permission: 'room.list'
    }
  },
  {
    name: 'room-edit',
    path: '/rooms/edit/:id',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Sala - Edição',
      icon: 'dvr',
      label: 'Sala - Edição',
      permission: 'room.edit'
    }
  },
  {
    name: 'room-show',
    path: '/rooms/:id/details',
    component: () => import(/* webpackChunkName: "event" */ './Show'),
    meta: {
      showNavbar: false,
      title: 'Sala',
      icon: 'dvr',
      label: 'Sala',
      permission: 'room.list'
    },
    children: [
      { path: '/rooms/:id/details/transmission', component: () => import(/* webpackChunkName: "event" */ './transmission/Index.vue'), name: 'room-transmission', meta: { permission: 'room.streaming' } },
      { path: '/rooms/:id/details/chat', component: () => import(/* webpackChunkName: "event" */ './chat/Index.vue'), name: 'room-chat', meta: { permission: 'room.chat' } },
      { path: '/rooms/:id/details/askings', component: () => import(/* webpackChunkName: "event" */ './askings/Index.vue'), name: 'room-askings', meta: { permission: 'room.asking' } },
      { path: '/rooms/:id/details/quiz', component: () => import(/* webpackChunkName: "event" */ './quiz/Index.vue'), name: 'room-quiz', meta: { permission: 'room.quiz' } },
      { path: '/rooms/:id/details/poll', component: () => import(/* webpackChunkName: "event" */ './poll/Index.vue'), name: 'room-poll', meta: { permission: 'room.poll' } },
      { path: '/rooms/:id/details/word-cloud', component: () => import(/* webpackChunkName: "event" */ './word-cloud/Index.vue'), name: 'room-word-cloud', meta: { permission: 'room.wordcloud' } },
      { path: '/rooms/:id/details/public-questions', component: () => import(/* webpackChunkName: "event" */ './public-questions/Index.vue'), name: 'room-public-questions', meta: { permission: 'room.asking' } },
      { path: '/rooms/:id/details/call-to-action', component: () => import(/* webpackChunkName: "event" */ './call-action/Index.vue'), name: 'room-call-to-action', meta: { permission: 'room.callaction' } },
      { path: '/rooms/:id/details/banners', component: () => import(/* webpackChunkName: "event" */ './banners/Index.vue'), name: 'room-banners', meta: { permission: 'room.banners' } }
    ]
  },
  {
    name: 'room-new',
    path: '/rooms/novo',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Sala - Adicionar',
      icon: 'dvr',
      label: 'Sala - Adicionar',
      permission: 'room.add'
    }
  },
  { path: '/rooms/:id/word-cloud/:wordCloudId', component: () => import(/* webpackChunkName: "event" */ './word-cloud/FullWordCloud'), name: 'room-word-result', meta: { permission: 'room.wordcloud' } },
  { path: '/poll/:pollId/chart', component: () => import(/* webpackChunkName: "event" */ './poll/FullChart'), name: 'room-poll-chart', meta: { permission: 'room.poll' } },
  { path: '/quiz/:quizId/chart', component: () => import(/* webpackChunkName: "event" */ './quiz/FullChart'), name: 'room-quiz-chart', meta: { permission: 'room.quiz' } }
]
